import { Box, Fade, Grid, Grow, Typography } from "@mui/material";
import { MyColorButton } from "../../layoutPages/components/MyColorButton";
import { ParentMeetingTopButtons } from "./ParentMeetingTopButtons";
import CreateIcon from '@mui/icons-material/Create';
import MapIcon from '@mui/icons-material/Map';
import { useState } from "react";
import { DefaultSetting } from "../../layoutPages/defaultSetting";
import { ShortCut } from "../../system/ShortCut";

export function PageParentApplication() {
    const [openMaps, setOpenMaps] = useState(false);

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <ParentMeetingTopButtons />
            <Grid item xs={11} sm={10}>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2} width={"100%"}>
                    <Grid>
                        <MyColorButton mainColor={"#f090a5"} inverted={true}
                            sx={{ fontSize: "1.5em", borderRadius: "5px", width: "350px", height: "55px", mt: 4 }}
                            onClick={() => { ShortCut.windowOpen("https://www.pkppf.hk/rga/enroll/step1/3039") }}
                        >
                            方法一:&nbsp;&nbsp;網上報名
                            <CreateIcon sx={{ ml: 2 }} />
                        </MyColorButton>
                    </Grid>
                    <Grid>
                        <MyColorButton mainColor={"#df7ca7"} inverted={true}
                            sx={{ fontSize: "1.5em", borderRadius: "5px", width: "350px", height: "55px", m: 4 }}
                            onClick={() => { setOpenMaps(!openMaps) }}
                        >
                            方法二:&nbsp;&nbsp;親身到培僑小學
                            <MapIcon sx={{ ml: 2 }} />
                        </MyColorButton>
                    </Grid>
                    {
                        openMaps &&
                        <Grow in={true} timeout={2000}>
                            <Box sx={{ p: 2, textAlign: "center" }}>
                                <Typography sx={{ m: 2, fontSize: "1.5rem", color: DefaultSetting.mainColor }}>
                                    小西灣富怡道12號
                                </Typography>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3692.367251235849!2d114.24757787654534!3d22.264074079712746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3404022fe99f233f%3A0x73e4dac6f802f4d6!2sPui%20Kiu%20Primary%20School!5e0!3m2!1sen!2shk!4v1724731444378!5m2!1sen!2shk" width="700" height="550" loading="lazy"></iframe>
                            </Box>
                        </Grow>
                    }
                </Grid>
            </Grid>
        </Grid>
    )
}